import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { useContext } from 'react'
import { usePortalQuery } from 'src/Libs/api'
import { getDynamicPricesSettings } from 'src/Libs/dynamic-power-prices/api/dynamic-prices-settings.api'
import { DynamicPricesModel } from 'src/Libs/dynamic-power-prices/types'
import { InstallationOnlineStatusContext } from 'src/Libs/installations/context/installation-online-status-context'

type ReturnType = {
  dynamicPowerPrices: DynamicPricesModel | null
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

export const getDynamicPowerPriceQueryKey = (storageId: string | undefined) => ['dynamic-prices-settings', storageId] as const

export const useFetchDynamicPowerPrice = (storageId: string | undefined, isEnabled = true): ReturnType => {
  const authFetch = useAuthFetchWithResponse()
  const { offlineClientStorageIds, isLoading: isOnlneStatusLoading } = useContext(InstallationOnlineStatusContext)

  const { data, isLoading, refetch, isError } = usePortalQuery({
    queryKey: getDynamicPowerPriceQueryKey(storageId),
    queryFn: () => getDynamicPricesSettings(storageId, authFetch, isEnabled),
    enabled: !!storageId && isEnabled && !isOnlneStatusLoading && !offlineClientStorageIds?.includes(storageId),
  })

  return {
    dynamicPowerPrices: data ?? null,
    isLoading,
    refetch,
    isError,
  }
}
